import React from 'react';
import { GetRef } from 'antd';
import Form, { Rule } from 'antd/es/form';
import { DefaultOptionType } from 'antd/es/select';
import { ColumnType } from 'antd/es/table';
import { ColumnFilterItem } from 'antd/es/table/interface';

type FormInstance = GetRef<typeof Form>;
export const EditableContext = React.createContext<FormInstance | null>(null);
export type RenderType = 'input' | 'select' | 'number' | 'date';

export interface CellAdditionProps<T> {
  dataIndex: keyof T;
  titleString?: string;
  editable?: boolean | ((record: T) => boolean);
  exportable?: boolean | ((record: T) => boolean);
  exportRender?: (value: any, data: T) => string;
  sortable?: boolean;
  filter?: boolean;
  renderType?: RenderType;
  renderOptions?: ((data: T) => DefaultOptionType[]) | DefaultOptionType[];
  /** True while `renderOptions` for this row are still loading. */
  optionsLoading?: boolean | ((data: T) => boolean);
  filterOptions?: ColumnFilterItem[];
  rules?: Rule[];
  /** When this cell changes, clear these sibling field values (deferred + form). */
  clearFieldsOnEdit?: (keyof T)[];
}

export type CustomColumns<T> = (ColumnType<T> & CellAdditionProps<T>)[];

export type ExtraTableExportData<T = any> =
  | T[]
  | {
      extraData: T[];
      defaultData?: unknown[];
    };

export type ExtraTableExport<T = any> = {
  key: string;
  label: string;
  fileName: string;
  columns: CustomColumns<T>;
  skipClientExport?: boolean;
  getExportData: (
    type?: 'csv' | 'pdf' | 'xlsx' | 'docx',
  ) => Promise<ExtraTableExportData<T>>;
};

export type TableExportOptions<T = any> = {
  fileName?: string;
  getExportData?: (type?: 'csv' | 'pdf' | 'xlsx' | 'docx') => Promise<T[]>;
  extraExports?: ExtraTableExport[];
  skipClientExport?: boolean;
  formats?: Array<'csv' | 'pdf' | 'xlsx' | 'docx'>;
  formatLabels?: Partial<Record<'csv' | 'pdf' | 'xlsx' | 'docx', string>>;
};

export type { DeferredInlineEditUpdate } from './InlineEditApplyContext';
